'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'motion/react';
import { useEffect, useRef, useState } from 'react';
import { Icon } from '@/components/icon';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
const MotionCard = motion.create(Card);
export function VideoCard(t0) {
  const $ = _c(58);
  const {
    videoUrl,
    isSelected,
    isFocused,
    isDragging,
    isAutoPlay,
    isPaused,
    setIsPaused,
    isMuted,
    toggleMute,
    onUserInteraction,
    onVideoEnd,
    aspectRatio: t1,
    className
  } = t0;
  const aspectRatio = t1 === undefined ? "aspect-[9/16]" : t1;
  const videoRef = useRef(null);
  const [isInViewport, setIsInViewport] = useState(false);
  const [showPauseButton, setShowPauseButton] = useState(false);
  const observerRef = useRef(null);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      observerRef.current = new IntersectionObserver(t4 => {
        const [entry] = t4;
        return setIsInViewport(entry.isIntersecting);
      }, {
        threshold: 0.5
      });
      if (videoRef.current) {
        observerRef.current.observe(videoRef.current);
      }
      return () => observerRef.current?.disconnect();
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[2] !== isAutoPlay || $[3] !== isInViewport || $[4] !== isPaused || $[5] !== isSelected) {
    t4 = () => {
      const video = videoRef.current;
      if (!video) {
        return;
      }
      if (isInViewport && isSelected && (isAutoPlay || !isPaused)) {
        video.play().catch(_temp);
        setShowPauseButton(!isAutoPlay);
      } else {
        video.pause();
        setShowPauseButton(false);
      }
    };
    t5 = [isInViewport, isSelected, isAutoPlay, isPaused];
    $[2] = isAutoPlay;
    $[3] = isInViewport;
    $[4] = isPaused;
    $[5] = isSelected;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[8] !== isMuted) {
    t6 = () => {
      const video_0 = videoRef.current;
      if (!video_0) {
        return;
      }
      video_0.muted = isMuted;
    };
    t7 = [isMuted];
    $[8] = isMuted;
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[11] !== onVideoEnd) {
    t8 = () => {
      const video_1 = videoRef.current;
      if (!video_1) {
        return;
      }
      const onEnded = () => {
        setShowPauseButton(false);
        onVideoEnd();
      };
      video_1.addEventListener("ended", onEnded);
      return () => video_1.removeEventListener("ended", onEnded);
    };
    t9 = [onVideoEnd];
    $[11] = onVideoEnd;
    $[12] = t8;
    $[13] = t9;
  } else {
    t8 = $[12];
    t9 = $[13];
  }
  useEffect(t8, t9);
  let t10;
  if ($[14] !== isMuted || $[15] !== toggleMute) {
    t10 = event => {
      event.stopPropagation();
      const newMuted = !isMuted;
      if (videoRef.current) {
        videoRef.current.muted = newMuted;
      }
      toggleMute();
    };
    $[14] = isMuted;
    $[15] = toggleMute;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const handleMute = t10;
  let t11;
  if ($[17] !== onUserInteraction || $[18] !== setIsPaused) {
    t11 = event_0 => {
      event_0.stopPropagation();
      const video_2 = videoRef.current;
      if (!video_2) {
        return;
      }
      onUserInteraction();
      if (!video_2.paused) {
        video_2.pause();
        setShowPauseButton(false);
        setIsPaused(true);
      } else {
        video_2.play().catch(_temp2);
        setShowPauseButton(true);
        setIsPaused(false);
      }
    };
    $[17] = onUserInteraction;
    $[18] = setIsPaused;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const handlePlayback = t11;
  let finalScale = 1;
  let brightness = 0.55;
  let boxShadow = "none";
  if (isFocused && isDragging) {
    finalScale = 1.05;
    brightness = 1;
    boxShadow = "0 2px 8px rgba(0, 0, 0, 0.2)";
  } else {
    if (isSelected && isDragging) {
      finalScale = 0.95;
      brightness = 0.7;
      boxShadow = "none";
    } else {
      if (isSelected) {
        finalScale = 1.08;
        brightness = 1;
        boxShadow = "0 4px 12px rgba(0, 0, 0, 0.3)";
      }
    }
  }
  let t12;
  if ($[20] !== isSelected || $[21] !== onUserInteraction || $[22] !== setIsPaused) {
    t12 = event_1 => {
      const video_3 = videoRef.current;
      if (!video_3 || !isSelected) {
        return;
      }
      onUserInteraction();
      if (!video_3.paused) {
        video_3.pause();
        setShowPauseButton(false);
        setIsPaused(true);
      } else {
        video_3.play().catch(_temp3);
        setShowPauseButton(true);
        setIsPaused(false);
      }
      event_1.stopPropagation();
    };
    $[20] = isSelected;
    $[21] = onUserInteraction;
    $[22] = setIsPaused;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const handleVideoClick = t12;
  let t13;
  if ($[24] !== aspectRatio || $[25] !== className) {
    t13 = cn("w-full cursor-pointer", aspectRatio, className);
    $[24] = aspectRatio;
    $[25] = className;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const t14 = `brightness(${brightness})`;
  let t15;
  if ($[27] !== boxShadow || $[28] !== finalScale || $[29] !== t14) {
    t15 = {
      scale: finalScale,
      filter: t14,
      boxShadow
    };
    $[27] = boxShadow;
    $[28] = finalScale;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== isSelected) {
    t16 = !isSelected ? {
      filter: "brightness(0.7)"
    } : {};
    $[31] = isSelected;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      duration: 0.2,
      ease: "easeOut"
    };
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== videoUrl) {
    t18 = <source src={videoUrl} type="video/mp4" />;
    $[34] = videoUrl;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== handleVideoClick || $[37] !== t18) {
    t19 = <video ref={videoRef} controls={false} playsInline={true} muted={true} onClick={handleVideoClick} className="absolute top-0 left-0 h-full w-full cursor-pointer object-cover object-center" preload="auto">{t18}</video>;
    $[36] = handleVideoClick;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== handlePlayback || $[40] !== isSelected || $[41] !== showPauseButton) {
    t20 = isSelected && <button type="button" className="absolute bottom-3 left-3 z-1 size-11 p-0 transition-opacity hover:opacity-80" onClick={handlePlayback} aria-label={showPauseButton ? "Pause" : "Play"}>{showPauseButton ? <Icon name="pause-reactions" className="size-full" /> : <Icon name="play-reactions" className="size-full" />}</button>;
    $[39] = handlePlayback;
    $[40] = isSelected;
    $[41] = showPauseButton;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== handleMute || $[44] !== isMuted || $[45] !== isSelected) {
    t21 = isSelected && <button type="button" className="absolute top-3 right-3 z-2 size-8 p-0 opacity-60 transition-opacity hover:opacity-90" onClick={handleMute} aria-label={isMuted ? "Unmute" : "Mute"}>{isMuted ? <Icon name="audio-off" className="size-full fill-christ-white-900 text-christ-black-900" /> : <Icon name="audio-on" className="size-full fill-christ-white-900 text-christ-black-900" />}</button>;
    $[43] = handleMute;
    $[44] = isMuted;
    $[45] = isSelected;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t19 || $[48] !== t20 || $[49] !== t21) {
    t22 = <CardContent className="absolute inset-0 p-0">{t19}{t20}{t21}</CardContent>;
    $[47] = t19;
    $[48] = t20;
    $[49] = t21;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t15 || $[52] !== t16 || $[53] !== t22) {
    t23 = <MotionCard animate={t15} whileHover={t16} transition={t17} className="relative h-full w-full gap-0 overflow-hidden rounded-none border-0 bg-christ-black-900 p-0 text-christ-white-900">{t22}</MotionCard>;
    $[51] = t15;
    $[52] = t16;
    $[53] = t22;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t13 || $[56] !== t23) {
    t24 = <div className={t13}>{t23}</div>;
    $[55] = t13;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  return t24;
}
function _temp3() {}
function _temp2() {}
function _temp() {}